module.exports = __webpack_public_path__ + "img/rune-fisker-dearly-departed.a77df4b.jpg";